import * as React from "react";
import { SFC } from "react";
import { Button, Form, Grid, Header } from "semantic-ui-react";
import Authentication from "../../../domain/authentication/Authentication";
import AutoLogin from "../../../domain/authentication/AutoLogin";
import LoginId from "../../../domain/authentication/LoginId";
import LoginPassword from "../../../domain/authentication/LoginPassword";
import Message from "../../../domain/fundamentals/message/Message";
import LoginErrorMessage from "./LoginErrorMessage";

interface Props {
  authentication: Authentication;
  message: Message;
  inputLoginId: (value: LoginId) => void;
  inputLoginPassword: (value: LoginPassword) => void;
  checkAutoLogin: (value: AutoLogin) => void;
  submit: () => void;
  isLoading: boolean;
}

const LoginForm: SFC<Props> = ({authentication, message, inputLoginId, inputLoginPassword, checkAutoLogin, submit, isLoading}) => (
  <>
    <Grid centered={ true } style={ {height: "100vh"} } verticalAlign="middle">
      <Grid.Column style={ {maxWidth: 450} }>
        <Header as="h2" color="grey" textAlign="center">
          ResKa ログイン
        </Header>

        <LoginErrorMessage message={ message }/>

        <Form size="large">
          <Form.Input
            label="ログインID"
            fluid={ true }
            icon="user"
            iconPosition="left"
            placeholder="ログインIDを入力してください"
            onChange={ (event, data) => inputLoginId(LoginId.of(data.value)) }
            value={ authentication.loginId.value }
            style={ {textAlign: "left"} }
          />
          <Form.Input
            label="パスワード"
            fluid={ true }
            icon="lock"
            iconPosition="left"
            type="password"
            placeholder="パスワードを入力してください"
            onChange={ (event, data) => inputLoginPassword(LoginPassword.of(data.value)) }
            value={ authentication.loginPassword.value }
            style={ {textAlign: "left"} }
          />
          <Form.Checkbox
            label="次回から自動ログインする"
            onChange={ (event, data) => checkAutoLogin(AutoLogin.of(data.checked ? data.checked : false)) }
            checked={ authentication.autoLogin.value }
          />
          <Button
            color="teal"
            fluid={ true }
            size="large"
            onClick={ () => submit() }
            loading={ isLoading }
          >
            ログイン
          </Button>
        </Form>
      </Grid.Column>
    </Grid>
  </>
);

export default LoginForm;